import type { ResultOf } from "@graphql-typed-document-node/core";
import { ErrorADT, safe } from "pb.safe";

import { query } from "../../../../schema.dev-sdk-api-appsync.generated";
import type { ApiClient } from "../shared/shared/api-client";

export async function getEntities({
	apiClient,
}: {
	apiClient: ApiClient;
}): Promise<
	| ResultOf<
			(typeof getEntities)["gql"]["getCustomerEntityMapping"]
	  >["getCustomerEntityMapping"]
	| ErrorADT<"NetworkFailure">
> {
	const response = await safe(() =>
		apiClient.request(getEntities.gql.getCustomerEntityMapping),
	);
	if (response instanceof Error) {
		return ErrorADT("NetworkFailure");
	}
	return response.getCustomerEntityMapping;
}

getEntities.gql = {
	getCustomerEntityMapping: query("getCustomerEntityMapping", (q) => [
		q.getCustomerEntityMapping((c) => [
			c.defaultEntityUuid,
			c.entityRelations((c) => [
				c.role,
				c.entityUuid,
				c.entity((c) => [c.name, c.tradingName, c.onboardingStatus]),
			]),
		]),
	]),
};
